import { useQuery, UseQueryResult } from '@tanstack/react-query';
import * as axios from 'axios';
import { AxiosResponse } from 'axios';
import { queryKeys } from '@/api/apiConfig';
import { CoordinatesRequest, CoordinatesResponse, CoordinatesViewResponse, LocationType } from '@/api/location/types';
import { ProblemDetails } from '@/generated/data.schemas';

export const getGeoCoding = async (
	address: string | null,
	key: string,
): Promise<AxiosResponse<CoordinatesResponse>> => {
	return axios.default.get(
		`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address as string)}&key=${key}`,
	);
};

export const useFindLocation = (
	params: CoordinatesRequest,
): UseQueryResult<LocationType | null, undefined | ProblemDetails> => {
	return useQuery({
		queryKey: queryKeys.location.coordinates(params).queryKey,
		queryFn: () => getGeoCoding(params.address, params.key),
		select: (res) => {
			if (res.status === 200) {
				return res.data.results[0].geometry.location;
			}
			return null;
		},
		enabled: !!params.address || params.address !== '',
	}) as UseQueryResult<LocationType | null, undefined | ProblemDetails>;
};

export const useLocationAutoComplete = (
	params: CoordinatesRequest,
): UseQueryResult<CoordinatesViewResponse, undefined | ProblemDetails> => {
	return useQuery({
		queryKey: queryKeys.location.coordinates(params).queryKey,
		queryFn: () => getGeoCoding(params.address, params.key),
		select: (res) => {
			if (res.status === 200) {
				return {
					status: res.data.status,
					addresses: res.data.results.filter(
						(o, index, arr) =>
							arr.findIndex((item) => item.formatted_address === o.formatted_address) === index,
					),
				};
			}
			return [];
		},
		enabled: !!params.address || params.address !== '',
	}) as UseQueryResult<CoordinatesViewResponse, undefined | ProblemDetails>;
};
